import { HttpService } from './http.service';

const SearchService = {
  SEARCH_API_HOST: process.env.VUE_APP_ADMIN_HOST,

  article(query, page) {
    return HttpService.httpGet(`${this.SEARCH_API_HOST}/api/search?q=${query}&page=${page}`);
  }
};

export default SearchService;
